import { inject } from "@angular/core";
import {
  Router,
  type ActivatedRouteSnapshot,
  type CanActivateFn,
  type UrlTree,
} from "@angular/router";

import { loginRedirectParams } from "../auth/login-redirect-params";
import { AuthStateService } from "../services/auth-state.service";

/**
 * Sends an unauthenticated visitor to the redirect interstitial, carrying the
 * local-dev `?org=` override across — see loginRedirectParams.
 */
export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (authState.isAuthenticated()) {
    return true;
  }

  // Auth0 refused this account for not being a member of the host's
  // organization. /login on a customer host would hand it straight back to
  // Auth0 to be refused again, so go to the screen that explains it.
  if (authState.refusal()?.kind === "not-a-member") {
    return router.createUrlTree(["/no-access"]);
  }

  return router.createUrlTree(["/login"], { queryParams: loginRedirectParams(route.queryParams) });
};
